import { IIdObject } from '@common/interfaces/id-object.interface';
import { IProductCatalogV2Object } from '../pack-house-generated-api';
import { ICachedItemPriceDto, createCachedItemPriceDto } from './cached-item-price.dto';
import { IS_DEBUG } from '@common/constants/is-debug.constant';

export interface IProductCatalogItemDto extends IIdObject {
  item:
  | ({
    prices: ICachedItemPriceDto[];
  } & Omit<IProductCatalogV2Object, 'prices'>)
  | undefined;
  price: number;
}

export const createProductCatalogItemDto = (product: IProductCatalogV2Object): IProductCatalogItemDto => {
  const prices = IS_DEBUG ?
    product.prices?.map((price) => createCachedItemPriceDto(price)) || []
    : product.prices?.filter((price) => price.period_unit == 'week').map((price) => createCachedItemPriceDto(price)) || [];
  return {
    id: product.id || '',
    price: product.price || 0,
    item: {
      ...product,
      prices,
      type: product.type
    }
  };
};
